module.exports = __webpack_public_path__ + "img/for_who_2_mobile.6ae9127.jpg";